<template>
  <div class="md-layout" v-bind:id='divId'>
    <div class="md-layout-item blindText md-display-1 rowLeft" v-bind:class="{ currentRow: blind.current, blindRow: (blind.type === 'blind' && !blind.current) , breakRow: (blind.type === 'break' && !blind.current) }">
      {{blind.timeIndexLabel}}
    </div>
    <div class="md-layout-item blindText md-display-1 rowMiddle" v-bind:class="{ currentRow: blind.current, blindRow: (blind.type === 'blind' && !blind.current) , breakRow: (blind.type === 'break' && !blind.current) }">
      {{blind.minutes}} m
    </div>
    <div class="md-layout-item blindText md-display-1 rowRight" v-bind:class="{ currentRow: blind.current, blindRow: (blind.type === 'blind' && !blind.current) , breakRow: (blind.type === 'break' && !blind.current) }">
      {{blind.message}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameBlindsRow',
  props: ['blind'],
  computed: {
    divId: function () {
      if (this.blind.current) {
        return 'blindCurrent'
      } else {
        return 'blind'
      }
    }
  }
}
</script>
<style lang="scss">
  .blindText {
    font-size: 1.25vw;
    line-height: 2vw;
    vertical-align: top;
  }
  .rowLeft{
    border-radius: 1vw 0px 0px 1vw;
    margin-top: 1px;
    margin-bottom: 1px;
    padding-left: 0.5vw;
    max-width: 4vw;
  }
  .rowMiddle{
    margin-top: 1px;
    margin-bottom: 1px;
    text-align: center;
    max-width: 5vw;
  }
  .rowRight{
    border-radius: 0px 1vw 1vw 0px;
    margin-top: 1px;
    margin-bottom: 1px;
  }
  .blindRow{
    background: rgb(89, 89, 89)
  }
  .breakRow{
    background-color: rgb(75, 75, 75)
  }
  .currentRow{
    background-color: rgb(179, 117, 26)
  }
</style>
